<template>
    <div>
        <div id="modalBuyExtraDomainConnection" class="modal inmodal fade" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <div>
                            <img class="top-img" src="/internacional/public/office3/img/dashboard/storage/domains.svg"/>
                            <h4 class="modal-title title" v-text="this.t.title"></h4>
                        </div>
                    </div>
                    <div class="modal-body" v-if="!this.allowed ">
                        <span v-if="this.is_website_agency" v-html="t.not_allowed_to_buy_extra_resources_wa"></span>
                        <span v-else v-html="t.not_allowed_to_buy"></span>
                        <div class="div__label">
                            <button class="btn-cancel button3" data-dismiss="modal" v-text="this.t.cancel"></button>
                        </div>
                    </div>
                    <div class="modal-body" v-else-if="!processing && price > 0">
                        <div class="line"></div>
                        <div class="div__label">
                            <span class="form__label" v-text="this.t.form_label + ':'"></span>
                        </div>
                        <div>
                            <input type="number" v-model="con" class="form-control" :min="this.sum" :step="this.sum"/>
                        </div>
                        <div class="div__label__price">
                            <span class="price__label">{{this.value}}</span>
                        </div>
                        <div class="div__label">
                            <button class="btn-domain button3" v-text="this.t.buy" @click="buy()"></button>
                            <button class="btn-cancel button3" data-dismiss="modal" v-text="this.t.cancel"></button>
                        </div>
                    </div>
                    <div class="modal-body" v-else>
                        <div class="line"></div>
                        <p style="font-style: italic;font-weight: 100;padding: 20px 10px; color: #9a9a9a;" v-text="this.t.label_processing"></p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import qs from 'qs';

    export default {
        name: "buy-extra-connection",
        props: [
            'translations', 'handlers', 'allowed', 'is_website_agency'
        ],
        data() {
            return {
                t : this.translations,
                h : this.handlers,
                value : null,
                con : null,
                qtd: 1,
                price: null,
                currency: null,
                sum: null,
                processing: false,

            }
        },
        mounted() {
            this.getPrices();
        },
        updated(){
            this.updateValue()
            setTimeout(this.fixQtd(), 1000);
        },
        methods: {
            //updates the price
            updateValue : function(){
                this.qtd = this.con / this.sum
                this.value = this.t.price + ': ' + this.currency + ' '+(this.qtd * this.price).toFixed(2) + ' / ' +this.t.period
            },

            buy : function(){

              let params = new URLSearchParams({
                  extraConnection: 1,
                  extraConnectionQtd: this.qtd
              });

              window.open(`${__env.checkout.url}/payment/${__env.checkout.slugs.extraConnection}?${params.toString()}`,'_TOP');
            },
            //update qtd to be a multiple of sum
            fixQtd: function(){
                if(this.con % this.sum != 0){
                    let m = Math.round(this.qtd, 1) > 0 ? Math.round(this.qtd, 1) : 1
                    this.con = this.sum * m
                }
            },

            getPrices: function(){

                if(!this.processing){
                    let vm = this
                    vm.processing = true

                    axios
                        .get(this.h.get_extra_connections_price)
                        .then(function(resposta) {
                            if (resposta.data.price) {
                                vm.price    = resposta.data.price;
                                vm.currency = resposta.data.currency;
                                vm.sum      = resposta.data.package;
                                vm.con      = vm.sum
                            }
                        })
                        .catch(function(error) {
                        })
                        .finally(function() {
                            vm.processing = false
                        });
                }
            }
        }
    };

</script>

<style scoped lang="scss">
    $green:#48D2A0;
    $red:#F54B5E;

    .title{
        margin-top: 10px;
        font-size: 25px;
        text-align: center;
    }
    .qtd__form{
        text-align: center;
    }
    .form__label{
        font-size: 20px;
    }

    .price__label{
        font-size: 20px;
        margin-top: 10px;
        float:right;
    }

    .div__label{
        margin-bottom: 5px;
        width: 100%;
        display: inline-block;
    }

    .div__label__price{
        margin-bottom: 5px;
        width: 100%;
        display: inline-block;
        margin-top: 20px;
    }

    .modal-body{
        padding: 0px 30px 10px 30px;

        button{
            margin: 30 auto;
            display: flex;
            width: 30%;
            justify-content: center;
            border-radius: 50px;
        }
    }

    .modal-header{
        padding: 15px 10px 5px 10px;

        .btn__close{
            padding: 0 10px;
            font-size: larger;
            display: contents;
        }
    }
    .btn-domain{
        margin-top: 30px;
        background-color: darken($green, 5%);
        float: right;
    }

    .btn-cancel{
        margin-top: 30px;
        margin-right: 10px;
        background-color: $red;
        float: right;
    }
    .top-img{
        display: block;
        margin: 0 auto;
    }

    .line{
        border-bottom: 2px solid #e0e2e459;
        width: 98%;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    .modal{
        top: 10%;
        @media only screen and (max-width: 600px) {
            top: 0;
        }
    }


</style>



// WEBPACK FOOTER //
// resources/office/js/components/domains-storage/buyExtraDomainConnection.vue